import { DatePicker, Select } from 'antd';
import { Tooltip } from 'antd/lib';
import React, { useMemo } from 'react';
import { values } from 'lodash/object';
import { keyBy } from 'lodash';


export const schedule_options = schedules => {
    return (Array.isArray(schedules) ? schedules : values(schedules)).map(schedule => ({
        label: (schedule?.isFuture?.() ? 'Future: ' : '') + schedule.scheduleName,
        value: schedule.scheduleId
    }));
};

function CalendarSelector({ charter, obj, onCalendarChange, onDatesChange, schedules, obsolete, recurring, hidePublicCalendars, ...props }) {
    const filteredSchedules = useMemo(() => {
        if(hidePublicCalendars) {
            return Array.isArray(schedules) ? schedules.filter(s => !s.shared) : values(schedules).filter(s => !s.shared);
        }
        return schedules;
    },[schedules, hidePublicCalendars]);
    const schedulesList = Array.isArray(filteredSchedules) ? filteredSchedules : values(filteredSchedules);
    const allSchedules = charter ? schedulesList : schedulesList.filter(s => !s.charter);
    const schedulesByKey = Array.isArray(filteredSchedules) ? keyBy(filteredSchedules, 'scheduleId') : filteredSchedules;

    // filter out deleted schedules
    const existingScheduleIds = obj.scheduleIds.filter(scheduleId => schedulesByKey[scheduleId]) || [];

    return (<Tooltip
        title={
            obsolete ? 'There is an expired Calendar for this service.' :
                !obj.scheduleIds?.length || !obj.dates?.length ? `Please provide at least one ${recurring ? 'Calendar' : 'Date'} for this service.` :
                    null
        }>
        {recurring && onCalendarChange ?
            <Select
                className={`w-100`}
                placeholder="Operating calendars"
                mode="multiple"
                allowClear
                showSearch={true}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                style={{ width: '100%' }}
                onChange={onCalendarChange}
                value={existingScheduleIds}
                options={schedule_options(allSchedules)}
                {...props}
            /> : onDatesChange ?
                <DatePicker multiple
                    maxTagCount="responsive"
                    onChange={onDatesChange} value={obj.dates}
                    {...props} /> :
                <>Please add onDatesChange function</>}
    </Tooltip>);
}

export default React.memo(CalendarSelector);